import React, { useEffect, useState } from "react";
import {
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  makeStyles,
  Typography,
  InputAdornment,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import StyledButton from "../../models/Button";
import SelectFilter from "../models/SelectFilter";
import { Autocomplete } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import MandatorySpan from "../../sasl/models/MandatorySpan";
import {
  presentDate,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import moment from "moment";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  submitBtn: {
    padding: "5px 16px",
    backgroundColor: "#e36e39",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid black",
    },
  },
  selectSearch: {
    "& .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedStart.MuiOutlinedInput-adornedStart.MuiInputBase-adornedEnd.MuiOutlinedInput-adornedEnd":
      {
        padding: "3px",
        paddingRight: "65px",
        paddingLeft: "9px",
      },
  },
  pad: {
    padding: "12px",
  },
  selectMenu: {
    minWidth: 120,
  },
}));

const ViewProjectMonthlyUtilization = () => {
  const classes = useStyles();
  const [sponsor, setSponsor] = useState("all");
  const [status, setStatus] = useState("all");
  const [compoundId, setCompoundId] = useState(null);
  const [filterResponse, setFilterResponse] = useState(null);
  const [filterData, setFilterData] = useState({
    sponsorList: [],
    statusList: [],
    compoundIdList: [],
  });
  const [selectedCompound, setSelectedCompound] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState({
    filterError: false,
    tableError: false,
    selectedFilterError: false,
  });

  const [viewTable, setViewTable] = useState(false);

  useEffect(() => {
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllProjects`
      )
      .then((res) => {
        if (res.data.status) {
          setFilterResponse(res.data.data);
          setFilterData({
            sponsorList: [
              ...new Set(res.data.data.map((item) => item.sponsorOrgName)),
            ],
            statusList: [
              ...new Set(res.data.data.map((item) => item.projectStatus)),
            ],
            compoundIdList: res.data.data.map((item) => {
              return {
                collabrixProjectID: item.collabrixProjectID,
                projectName: item.projectName,
              };
            }),
          });
        } else {
          setError({
            ...error,
            filterError: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setError({
          ...error,
          filterError: true,
        });
      });
  }, []);

  useEffect(() => {
    if (
      Array.isArray(filterResponse) &&
      (sponsor !== "all" || status !== "all")
    ) {
      setFilterData({
        ...filterData,
        compoundIdList:
          sponsor !== "all" && status !== "all"
            ? filterResponse
                .filter(
                  (val) =>
                    val.projectStatus === status &&
                    val.sponsorOrgName === sponsor
                )
                .map((item) => {
                  return {
                    collabrixProjectID: item.collabrixProjectID,
                    projectName: item.projectName,
                  };
                })
            : sponsor !== "all"
            ? filterResponse
                .filter((val) => val.sponsorOrgName === sponsor)
                .map((item) => {
                  return {
                    collabrixProjectID: item.collabrixProjectID,
                    projectName: item.projectName,
                  };
                })
            : filterResponse
                .filter((val) => val.projectStatus === status)
                .map((item) => {
                  return {
                    collabrixProjectID: item.collabrixProjectID,
                    projectName: item.projectName,
                  };
                }),
      });
    } else if (Array.isArray(filterResponse)) {
      setFilterData({
        ...filterData,
        compoundIdList: filterResponse.map((item) => {
          return {
            collabrixProjectID: item.collabrixProjectID,
            projectName: item.projectName,
          };
        }),
      });
    }
  }, [sponsor, status]);

  const handleSponsorChange = (event) => {
    setCompoundId(null);
    setSelectedCompound(null);
    setViewTable(false);
    setError({
      ...error,
      tableError: false,
      selectedFilterError: false,
    });
    setSponsor(event.target.value);
  };

  const handleStatusChange = (event) => {
    setCompoundId(null);
    setSelectedCompound(null);
    setViewTable(false);
    setError({
      ...error,
      tableError: false,
      selectedFilterError: false,
    });
    setStatus(event.target.value);
  };

  const handleCompoundIdChange = (value) => {
    setViewTable(false);
    setError({
      ...error,
      tableError: false,
      selectedFilterError: false,
    });
    setSelectedCompound(null);
    if (filterResponse && value) {
      let selected = filterResponse.filter(
        (val) => val.collabrixProjectID === value.collabrixProjectID
      );
      setSelectedCompound(selected.length > 0 ? selected[0] : null);
    }
    setCompoundId(value);
  };

  const handleViewTable = () => {
    if (selectedCompound) {
      setTableLoading(true);
      setViewTable(true);
      const data = {
        collabrixProjectID: selectedCompound.projectName,
        assignedFTEMonths: selectedCompound.assignedFTEMonths,
        assignedBudget: selectedCompound.assignedBudget,
      };
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchCumulativeFTEUtilizationData`,
          data
        )
        .then((res) => {
          if (res.data.status) {
            setTableData(res.data.data.monthWiseUtilizationReportList);
            setTableLoading(false);
          } else {
            setError({
              ...error,
              tableError: true,
            });
            setTableLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setError({
            ...error,
            tableError: true,
          });
          setTableLoading(false);
        });
    } else {
      setError({ ...error, selectedFilterError: true });
    }
  };

  return (
    <React.Fragment>
      {error.filterError && (
        <Grid container item alignItems="center" justifyContent="center">
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "50px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              width: "50%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>
        </Grid>
      )}

      {error.selectedFilterError && (
        <Grid container item alignItems="center" justifyContent="center">
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "50px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              width: "50%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Please Select Compound ID.
            </Typography>
          </div>
        </Grid>
      )}

      <Grid
        container
        alignItems="center"
        style={{ paddingBottom: "2rem", paddingTop: "1rem" }}
      >
        <Grid item xs={12} sm={10} md={9}>
          <Grid container spacing={5} alignItems="center">
            <Grid item xs={12} sm={3}>
              <Typography
                variant="body2"
                style={{ fontWeight: 500, marginBottom: "10px" }}
              >
                Filter by BMS:
              </Typography>
              <FormControl fullWidth className={classes.selectMenu}>
                <Select
                  disabled={false}
                  value={sponsor}
                  onChange={handleSponsorChange}
                  variant="outlined"
                  classes={{ root: classes.pad }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        height:
                          filterData.sponsorList.length > 1 ? "27%" : "16%",
                        overflowY:
                          filterData.sponsorList.length > 1
                            ? "scroll"
                            : "hidden",
                      },
                    },
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  {filterData.sponsorList.map((val, index) => (
                    <MenuItem key={index} value={val}>
                      {val}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <SelectFilter disabled={false} value={sponsor} objectArray={filterData.sponsorList} /> */}
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography
                variant="body2"
                style={{ fontWeight: 500, marginBottom: "10px" }}
              >
                Filter by Project Status:
              </Typography>
              <FormControl fullWidth className={classes.selectMenu}>
                <Select
                  disabled={false}
                  value={status}
                  onChange={handleStatusChange}
                  variant="outlined"
                  classes={{ root: classes.pad }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        height:
                          filterData.statusList.length > 1 ? "27%" : "16%",
                        overflowY:
                          filterData.statusList.length > 1
                            ? "scroll"
                            : "hidden",
                      },
                    },
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  {filterData.statusList.map((val, index) => (
                    <MenuItem key={index} value={val}>
                      {val}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <SelectFilter disabled={false} value={status}  objectArray={filterData.statusList} /> */}
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography
                variant="body2"
                style={{ fontWeight: 500, marginBottom: "10px" }}
              >
                Select Compound ID:
                <MandatorySpan />
              </Typography>
              <Autocomplete
                className={classes.selectSearch}
                options={filterData.compoundIdList}
                getOptionLabel={(option) => option.projectName}
                value={compoundId}
                onChange={(event, newValue) => {
                  handleCompoundIdChange(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select or search compound ID"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3} style={{ alignSelf: "flex-end" }}>
              <StyledButton
                onClick={handleViewTable}
                className={classes.submitBtn}
              >
                View Utilization
              </StyledButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {viewTable && (
        <React.Fragment>
          <Divider />
          <TableContainer
            component={Paper}
            style={{ margin: "2rem auto", boxShadow: "none" }}
          >
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f9fc" }}>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      maxWidth: "100px",
                    }}
                    align="left"
                  >
                    Compound ID
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      maxWidth: "100px",
                    }}
                    align="left"
                  >
                    Account Code
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      maxWidth: "100px",
                    }}
                    align="left"
                  >
                    Start Date
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      maxWidth: "100px",
                    }}
                    align="left"
                  >
                    End Date (expected)
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      maxWidth: "50px",
                    }}
                    align="right"
                  >
                    Assigned FTE Months
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      maxWidth: "100px",
                    }}
                    align="right"
                  >
                    Assigned Budget
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow style={{ backgroundColor: "#f5f9fc" }}>
                  <TableCell align="left">
                    {presentFormatedData(selectedCompound.collabrixProjectID)}
                  </TableCell>
                  <TableCell align="left">
                    {presentFormatedData(selectedCompound.accountCode)}
                  </TableCell>
                  <TableCell align="left">
                    {moment(
                      selectedCompound?.projectStartDate,
                      "YYYY-MM-DD"
                    ).isValid()
                      ? moment(
                          selectedCompound.projectStartDate,
                          "YYYY-MM-DD"
                        ).format("DD-MMM-YYYY").toUpperCase()
                      : " - "}
                  </TableCell>
                  <TableCell align="left">
                    {moment(
                      selectedCompound?.projectEndDate,
                      "YYYY-MM-DD"
                    ).isValid()
                      ? moment(
                          selectedCompound.projectEndDate,
                          "YYYY-MM-DD"
                        ).format("DD-MMM-YYYY").toUpperCase()
                      : " - "}
                  </TableCell>
                  <TableCell align="right">
                    {presentFormatedData(selectedCompound.assignedFTEMonths)}
                  </TableCell>
                  <TableCell align="right">
                    {selectedCompound.assignedBudget
                      ? new Intl.NumberFormat().format(
                          selectedCompound.assignedBudget
                        )
                      : " - "}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Typography style={{ fontWeight: "bold" }}>
            Monthly and Cumulative Utilization by Project
          </Typography>
          <TableContainer component={Paper} style={{ margin: "20px auto" }}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell align="left" style={{ fontWeight: "bold" }}>
                    Month
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Year
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    FTE Months
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Budget
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Cumulative FTE Months Spend
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Cumulative Budget Spend
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    FTE Available
                  </TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>
                    Budget Available
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableLoading ? (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={8}>
                      <div style={{ textAlign: "center" }}>
                        <CircularProgress color="primary" />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : error.tableError ? (
                  <TableRow
                    style={{
                      border: "2px solid #FF0000",
                      backgroundColor: "#FFF0F0",
                    }}
                  >
                    <TableCell colSpan={8} align="center">
                      Something went wrong. Please try again later.
                    </TableCell>
                  </TableRow>
                ) : tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No Records Found
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        {presentFormatedData(row.monthName)}
                      </TableCell>
                      <TableCell align="right">
                        {presentFormatedData(row.year)}
                      </TableCell>
                      <TableCell align="right">
                        {presentFormatedData(row.FTEMonths)}
                      </TableCell>
                      <TableCell align="right">
                        {presentFormatedData(
                          new Intl.NumberFormat().format(row.Budget)
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {presentFormatedData(
                          new Intl.NumberFormat().format(
                            row.cumulativeFTEMonthSpend
                          )
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {presentFormatedData(
                          new Intl.NumberFormat().format(
                            row.cumulativeBudgetSpend
                          )
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {presentFormatedData(
                          new Intl.NumberFormat().format(row.FTEAvailable)
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {presentFormatedData(
                          new Intl.NumberFormat().format(row.budgetAvailable)
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ViewProjectMonthlyUtilization;
